module.exports = __webpack_public_path__ + "ff13b6b99c3fdb59e98f1354c1fe45e8.pdf";